import { Middleware } from 'redux';
import {
    FETCH_TIMINGS_SUCCEEDED,
    FETCH_MATCH_FEEDS_REQUESTED,
    PHASE_CHANGE,
    PROPAGATE_COUNTDOWN_BY_CHANNEL,
    REQUEST_CURRENT_PHASE_DATA,
    BETSTOP_CHANGE,
    INIT_APPLICATION_STARTED,
    CHANGE_CHANNEL,
    PHASE_CHANGE_ON_ACTIVE_CHANNEL,
    MATCH_PURGE,
    FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED, FETCH_STATS_TEAM_LAST_X_REQUESTED
} from '../actions/actionTypes';
import { getTimings, getActiveTimingsChannel, getPhaseIdByMatchId, getChannelIdByMatchId, getNextBetstopByChannelId, getMatchIdsForChannelsWithNewPhases, getChannelByChannelId, getNumberOfMatchesInStore, calculateCurrentServerTimeMs, getActiveMatchId } from '../reducers/timings';
import { IState, ITimingsChannel } from '../store/state';
import { getActiveChannelId, getBetstopByMatchId, getInitApplicationState } from '../reducers/gui';
import { PHASE_BETSTOP, PHASE_RALLY, PHASE_POST_MATCH, PHASE_PRE_GAME } from '../api/phases';
import { phaseChange } from '../actions/customerMethods';
import {EVENT_MATCH_ENDED, getPlayerUidsByMatchId} from '../reducers/matches';
import createWebWorker from '../utils/createWebWorker';
import TimingsWebWorker from '../webworkers/timings.js';
import { getBaseUrl } from '../reducers/config';

// Countdowns are reduced by this number to end the countdown early, because we want to prevent situations where a punter can't place bets exactly when the countdown ends
//! const COUNTDOWN_ADVANCE_MS = -2000;

const timingsMiddleware: Middleware = store => next => action => {
    switch (action.type) {
        case INIT_APPLICATION_STARTED:
            // timings are fetched inside a webworker
            timingsWebWorker(store)
            break;
        case FETCH_TIMINGS_SUCCEEDED:
            // need old timings for phase comparison
            const oldTimings = getTimings(store.getState() as any as IState);
            // need new timings in store for further work
            const result = next(action);
            handleTimingsUpdate(store, oldTimings);
            return result;
        case REQUEST_CURRENT_PHASE_DATA:
            propagateCountdownByChannel(store, getActiveTimingsChannel(store.getState() as any as IState));
            break;
        case CHANGE_CHANNEL:
            const channel = (action as any).id;
            const timings = getChannelByChannelId(store.getState() as any as IState, channel);
            propagateCountdownByChannel(store, timings);
            propagateBetstopByChannel(store,timings,true);
            propagateHead2HeadFormByChannel(store, channel, timings);
            break;
    }
    return next(action);
}



/**
 * instanciates new Worker via WebWorkerEnabler with TimingsWebWorker as code
 * @param       store                               to get options and dispatch actions
 * @message     sending START_FETCH_TIMINGS         to start the process of fetching the timings feed at that datas url
 * @message     sending RESUME_FETCH_TIMINGS        to clear and restart process of fetching the timings feed
 * @message     recieving PAUSE_FETCH_TIMINGS       to stop the process of fetching the timings feed
 * @message     recieving FETCH_TIMINGS_SUCCEEDED   to transfer timings feed data
 * @message     recieving FETCH_TIMINGS_FAILED      to indicate error
 * @message     recieving FETCH_TIMINGS_ERROR       to indicate error
 */
const timingsWebWorker = (store : any) => {
    const state : IState = store.getState()

    // instanciate timingsWebWorker
    const timingsWebWorker = (window as any).timingsWebWorker = createWebWorker(TimingsWebWorker)

    //const timingsFeedUrl:string = location.protocol+getHost(state)+getBaseUrl(state)+'mobile/timings'
    const timingsFeedUrl:string = getBaseUrl(state)+'mobile/timings'

    // activate timingsWebWorker and start fetching the timings feed at that datas url
    timingsWebWorker.postMessage(JSON.stringify({ 
        name: 'START_FETCH_TIMINGS', 
        data: timingsFeedUrl
    }))

    // message action
    timingsWebWorker.onmessage = (event: any) => {
        const messageObject = JSON.parse(event.data)
        switch(messageObject.name) {
            case 'FETCH_TIMINGS_SUCCEEDED':
                store.dispatch( { type: FETCH_TIMINGS_SUCCEEDED, data: messageObject.data } )
                break;
            case 'FETCH_TIMINGS_FAILED':
            case 'FETCH_TIMINGS_ERROR':
                console.warn('timingsWebWorker error - sending START_FETCH_TIMINGS again')
                timingsWebWorker.postMessage(JSON.stringify({ 
                    name: 'START_FETCH_TIMINGS', 
                    data: timingsFeedUrl
                }))
                break;
            default:
                console.warn('no valid name for message from timingsWebWorker')
        }
    }

    // error action
    timingsWebWorker.onerror = (event: any) => {
        console.warn('timingsWebWorker error - sending START_FETCH_TIMINGS again')
        timingsWebWorker.postMessage(JSON.stringify({ 
            name: 'START_FETCH_TIMINGS', 
            data: timingsFeedUrl
        }))
    }

}



const handleTimingsUpdate = (store:any, oldTimings: ITimingsChannel[]) : void => {
    const state = store.getState() as any as IState;
    const newTimings = getTimings(state);
    const changeChannelMatchIds : number[] = getMatchIdsForChannelsWithNewPhases(state);

    for (let channelTiming of newTimings) {
        const oldTiming = oldTimings.find((timing: any) => timing.id === channelTiming.id);
        if (!oldTiming || channelTiming.phase_id !== oldTiming.phase_id) {
            const matchId = channelTiming.match_id;
            
            if( getInitApplicationState(state) ) {
                // trigger fetch of match dependent feeds for channels with phase changes
                store.dispatch( { type: FETCH_MATCH_FEEDS_REQUESTED, matchId: matchId} );
            }

            propagateBetstopByChannel(store, channelTiming);
            propagateCountdownByChannel(store, channelTiming);

            const phaseId = getPhaseIdByMatchId(state,matchId);
            const numberOfMatchesInStore = getNumberOfMatchesInStore(state);
            if(phaseId === PHASE_PRE_GAME && numberOfMatchesInStore >= 6) {
                for (let matchId in state.matches) {
                    // delete the finished match(es) (with a "match ended" event)
                    if (state.matches[matchId].lastEvent._typeid == EVENT_MATCH_ENDED) {
                        store.dispatch( { type: MATCH_PURGE, id: matchId } );
                    }
                }
            }
        }
    }
    if( changeChannelMatchIds.length ) {
        store.dispatch({type: PHASE_CHANGE, data: changeChannelMatchIds});
    }
}

const propagateBetstopByChannel = (store:any, channelTiming: ITimingsChannel, force?: boolean) : void => {
    const state = store.getState() as any as IState;

    const matchId = channelTiming.match_id;
    const activeChannelId = getActiveChannelId(state);

    // Why did we use previous betstop before
    const lastBetstopState = getBetstopByMatchId(state,matchId);
    let phaseId = getPhaseIdByMatchId(state,matchId);
    let channelId = getChannelIdByMatchId(state,matchId);

    // in betstop, rally and match end phases set betstop state to true
    let newBetstopState = [PHASE_BETSTOP,PHASE_RALLY,PHASE_POST_MATCH].includes(phaseId);

    if( channelId == getActiveChannelId(state) ) {
        // Reset manual mode (show overlay) when the phase changes
        store.dispatch({type: PHASE_CHANGE_ON_ACTIVE_CHANNEL, data: phaseId});
    }

    if(force || (lastBetstopState !== newBetstopState)) {
        store.dispatch({type: BETSTOP_CHANGE, matchId: matchId, isBetstop: newBetstopState, isActiveChannel: activeChannelId === channelTiming.id});
        const nextBetstop = getNextBetstopByChannelId(state,channelId);

        // event to be sent; contains the id of the match running in channel X and the time until the next betstop
        // TODO do we really need to use the phaseChange event here???
        let actionMatchStart = phaseChange({
            event_start: nextBetstop,
            event_id: matchId,
            unified_event_id: 'vti:match:' + matchId // TODO: replace the string with unifiedEventId
        });
        store.dispatch(actionMatchStart);
    }
}

const propagateCountdownByChannel = (store:any, channelTiming: ITimingsChannel) : void => {
    let countdown = 0;
    const isBetstop = [PHASE_BETSTOP, PHASE_RALLY, PHASE_POST_MATCH].includes(channelTiming.phase_id);
    if( !isBetstop ) {
        const bestopStart = channelTiming.betstop_datetime*1000;
        const currentServerTime = calculateCurrentServerTimeMs(store.getState());
        // Advance the countdown and round down
        countdown = Math.floor((bestopStart-currentServerTime)/1000);
        if( countdown < 0 ) {
            countdown = 0;
        }
    } 
    store.dispatch({type: PROPAGATE_COUNTDOWN_BY_CHANNEL, data: {
        countdown: countdown, channelId: channelTiming.id, phaseId: channelTiming.phase_id
    }});
}

const propagateHead2HeadFormByChannel = (store: any, channelId: number, channelTiming: ITimingsChannel) : void => {
    const state = store.getState() as any as IState;
    const matchId = channelTiming.match_id;
    const clubIds = getPlayerUidsByMatchId(state, matchId);

    store.dispatch( { type: FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED, teamIdA: clubIds.home, teamIdB: clubIds.away, channelId } );
    store.dispatch( { type: FETCH_STATS_TEAM_LAST_X_REQUESTED, teamIdA:clubIds.home, teamIdB:clubIds.away, channelId } );
}

export default timingsMiddleware;
